import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

export interface Tutor {
    id: number;
    email: string;
    username: string;
}

export interface Student {
    id: number;
    username: string;
    email: string;
    year_group: string;
}

export interface QuestionType {
    id: number;
    name: string;
    description: string;
    subject_id: number;
    image_url: string;
    status: boolean;
}

export interface SubjectDetails {
    id: number;
    name: string;
    start_date?: string;
    end_date?: string;
}

export interface Booklet {
    id: number;
    name: string;
    title?: string;
}

export interface VideoLesson {
    id: number;
    title: string;
    video_id: string;
}

export interface ScheduleSetupData {
    tutors: Tutor[];
    subjects: SubjectDetails[];
    students: Student[];
    question_types: QuestionType[];
    booklets?: Booklet[];
    video_lessons?: VideoLesson[];
    formula_notes?: any[];
    mapped_booklets?: Booklet[];
    mapped_video_lessons?: VideoLesson[];
    mapped_formula_notes?: any[];
    unmapped_booklets?: Booklet[];
    unmapped_video_lessons?: VideoLesson[];
    unmapped_formula_notes?: any[];
    time_filter: {
        start_time: string;
        end_time: string;
        availability_filtered: boolean;
    };
}

export interface ScheduleSetupPayload {
    course_id: string;
    start_time: string;
    end_time: string;
}

const initialState: IReduxState<ScheduleSetupData> = {
    data: {
        status: false,
        message: "",
        data: {
            tutors: [],
            subjects: [],
            students: [],
            question_types: [],
            booklets: [],
            video_lessons: [],
            formula_notes: [],
            mapped_booklets: [],
            mapped_video_lessons: [],
            mapped_formula_notes: [],
            unmapped_booklets: [],
            unmapped_video_lessons: [],
            unmapped_formula_notes: [],
            time_filter: {
                start_time: "",
                end_time: "",
                availability_filtered: false
            }
        }
    },
    isLoading: false,
    error: null
} as IReduxState<ScheduleSetupData>;

export const ScheduleSetupDataSlice = createSlice({
    name: "ScheduleSetupDataSlice",
    initialState,
    reducers: {
        getScheduleSetupData: (state, _action: PayloadAction<ScheduleSetupPayload>) => {
            state.isLoading = true;
            state.error = null;
        },
        successGetScheduleSetupData: (state, action: PayloadAction<IAPIResponse<ScheduleSetupData>>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureGetScheduleSetupData: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    getScheduleSetupData,
    successGetScheduleSetupData,
    failureGetScheduleSetupData,
} = ScheduleSetupDataSlice.actions;

export default ScheduleSetupDataSlice.reducer;
